import { Injectable } from '@angular/core';
import { IContact, ICustomerDetails } from '@dxp/core/models';
import { Subject } from 'rxjs';

interface IContactServiceSubject {
    type: 'contacts' | 'customers';
    contact: IContact | ICustomerDetails;
}

@Injectable({
    providedIn: 'root',
})
export class ContactService {
    #contactUpdateSubject: Subject<IContactServiceSubject> =
        new Subject<IContactServiceSubject>();

    contactUpdated$ = this.#contactUpdateSubject.asObservable();

    setContactUpdate(contacUpdate: IContactServiceSubject): void {
        this.#contactUpdateSubject.next(contacUpdate);
    }
}
